const CalendarDays = ({ days, changeCurrentDay }) => {
  const firstDayOfMonth = new Date(days.getFullYear(), days.getMonth(), 1);
  const weekdayOfFirstDay = firstDayOfMonth.getDay();
  let currentDays = [];

  for (let day = 0; day < 42; day++) {
    if (day === 0 && weekdayOfFirstDay === 0) {
      firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 7);
    } else if (day === 0) {
      firstDayOfMonth.setDate(
        firstDayOfMonth.getDate() + (day - weekdayOfFirstDay)
      );
    } else {
      firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
    }

    let calendarDay = {
      currentMonth: firstDayOfMonth.getMonth() === days.getMonth(),
      date: new Date(firstDayOfMonth),
      month: firstDayOfMonth.getMonth(),
      number: firstDayOfMonth.getDate(),
      selected: firstDayOfMonth.toDateString() === new Date().toDateString(),
      year: firstDayOfMonth.getFullYear(),
    };

    currentDays.push(calendarDay);
  }
  return (
    <div className="w-full grow flex box-border justify-between flex-wrap">
      {currentDays.map((day,index) => {
        return (
          <div
            key={index}
            className={
              "w-[35px] h-[35px] relative text-center" +
              (day.currentMonth ? " text-black" : " text-[#a6a6a6]") +
              (day.selected ? " border rounded-xl border-black bg-gray-200" : "")
            }
          >
            <p className="absolute right-0 left-0 py-2 m-auto w-fit">{day.number}</p>
          </div>
        );
      })}
    </div>
  );
};

export default CalendarDays;
